import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      La niña harapienta tiene hambre y frío, pero lo que más le duele es la soledad. Guarda entonces un regalo especial
      para el caballito sagrado que los monjes conservan en el templo. Se trata de una corteza de pan, lo único que
      tiene. La intimidad de la noche le permite acercarse al animal sin que nadie la espante, y solo así pueden hablar.
    </p>
    <p className="content justified">
      Esta narración, llevada al radioteatro por Don Os y el grupo radioteatral de la Radiodifusora en 1955, tiene
      muchos de los elementos comunes de las historias contadas de abuelos a nietos a través de la tradición oral: unas
      palabras (mágicas) que se repiten (“Los dioses lo saben”), una niña miserable que sueña con tener alimento y
      abrigo, y un ser rico que sueña con ser libre, unas lágrimas de amor sincero que caen sobre un animal encantado y
      lo convierten en príncipe y una moraleja.
    </p>
    <p className="content justified">
      Al momento de escuchar los radioteatros de la serie <i>Leyendas</i> cabe preguntarnos por la curaduría de las
      narraciones, es decir, ¿qué hizo que Oswaldo Díaz Díaz eligiera ciertas historias y las llevara a la radio?
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Y podemos notar varios elementos que Don Os incluye no solo en su selección, sino también en la creación de sus
      propias historias y obras de teatro: el tema de la virtud, el valor verdadero de las cosas (que va más allá de las
      riquezas), la trascendencia, las situaciones precarias que se ven superadas por el tesón de los protagonistas.
    </p>
    <p className="content justified">
      Esta serie se caracterizó por incluir historias de tradición oral de diversos lugares del mundo. A través de ellas
      no solo nos podemos acercar a la forma de ver el mundo de otras culturas, sino que notamos cómo hay una serie de
      situaciones, personajes y conflictos que se mantienen en ellas, sin importar su lugar de origen o la época en las
      que fueron creadas.
    </p>
    <p className="content justified">
      La historia de “Los dioses lo saben” es una de las más bellas de lo que pudimos encontrar en esta serie Leyendas,
      no solo por la belleza y delicadeza en el lenguaje, o por la impecable representación del grupo radioteatral, sino
      por la profundidad y la dulzura con la que esta narración fue llevada a la radio y se mantiene vigente a pesar de
      que se haya grabado hace más de 50 años.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
